import { render, staticRenderFns } from "./ExemptionViewProfile.vue?vue&type=template&id=675fb267&scoped=true&"
import script from "./ExemptionViewProfile.vue?vue&type=script&lang=js&"
export * from "./ExemptionViewProfile.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionViewProfile.vue?vue&type=style&index=0&id=675fb267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675fb267",
  null
  
)

export default component.exports